import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { AuditorCompetenceDetail } from '@/common';
import env from '@/env';

type Body = {
  name?: string;
  note?: string;
  validFrom?: string;
  validTo?: string;
  compTypeId?: string;

  [key: string]: any;
};

export const updateAuditorCompetence = async ({
  id,
  data,
}: {
  id: string;
  data: Body;
}): Promise<AuditorCompetenceDetail> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-comps/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorCompetenceDetail;
  return response;
};
